import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { colores } from '../../styles/variablesCss';
import { BACKEND_URL } from '../../Config/Const';
import Storage from '../../utils/Storage';
import FeedbackModal from '../Common/FeedbackModal';

const CuponDescuento = ({ cupon, setCupon, cargando, setDescuentoAplicado, onCuponTotals }) => {
  const [cargandoCupon, setCargandoCupon] = useState(false);
  const [errorCupon, setErrorCupon] = useState(null);
  const [feedback, setFeedback] = useState({ visible: false, type: 'success', title: '', message: '' });

  // Función para validar y aplicar el cupón
  const validarCupon = async () => {
    // Si no hay cupón, mostrar error
    if (!cupon?.trim()) {
      setErrorCupon('Debes ingresar un código de cupón');
      return;
    }

    try {
      setCargandoCupon(true);
      setErrorCupon(null);

      // Obtener datos de autenticación del almacenamiento
      const mail = await Storage.getItem('mail') || '';
      const codUsu = await Storage.getItem('codUsu') || '';
      const suc = await Storage.getItem('sucursalId') || '4';

      // Si no hay usuario autenticado, mostrar error
      if (!mail && !codUsu) {
        setErrorCupon('Debes iniciar sesión para aplicar un cupón');
        setCargandoCupon(false);
        return;
      }

      // Construir la URL con query parameters
      const queryParams = new URLSearchParams({
        mail, codUsu, suc, codPromo: cupon
      }).toString();

      const apiUrl = `${BACKEND_URL}/rest/fin/cupon?${queryParams}`;
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });

      // Verificar si la respuesta es exitosa
      if (!response.ok) throw new Error('Error en la respuesta del servidor');

      // Convertir respuesta a JSON
      const data = await response.json();

      // La API devuelve dsResultado.resultado[0].resultado === true y totales en dsResultado.total[0]
      const ok = data?.dsResultado?.resultado?.[0]?.resultado === true;
      if (ok) {
        const totals = data?.dsResultado?.total?.[0] || null;
        // totals esperado: { subtotal, descuentos, descuentoCupon, precioEnvio, percepciones, total }

        if (totals) {
          // Notificar al padre los totales del cupón para que reemplace los cálculos
          if (onCuponTotals) onCuponTotals(totals);

          // También exponer el descuento de cupón en el estado previo si lo usan
          if (setDescuentoAplicado && typeof totals.descuentoCupon === 'number') {
            setDescuentoAplicado(totals.descuentoCupon);
          }

          setFeedback({ visible: true, type: 'success', title: 'Exito', message: 'Cupón Aplicado' });
        } else {
          setErrorCupon('La respuesta no incluye los totales del cupón');
          Alert.alert('Error', 'La respuesta no incluye los totales del cupón');
        }
      } else {
        const mensaje = data?.dsResultado?.resultado?.[0]?.mensaje || data?.dsResultado?.mensaje || 'Cupón inválido o expirado';
        setErrorCupon(mensaje);
        Alert.alert('Cupón inválido', mensaje);
      }
    } catch (error) {
      setErrorCupon('Error al validar el cupón. Intenta nuevamente.');
      Alert.alert('Error', 'No se pudo validar el cupón en este momento. Por favor, intenta nuevamente.');
    } finally {
      setCargandoCupon(false);
    }
  };

  return (
    <>
      <Text style={styles.tituloSeccion}>¿Tenés un cupón de descuento?</Text>
      <View style={styles.cuponContainer}>
        <TextInput
          style={styles.cuponInput}
          placeholder="#CÓDIGODESCUENTO"
          placeholderTextColor={colores.grisClaro}
          value={cupon}
          onChangeText={setCupon}
        />
        <TouchableOpacity
          style={styles.cuponBoton}
          onPress={validarCupon}
          disabled={cargandoCupon || cargando}
        >
          <Text style={styles.cuponBotonTexto}>
            {cargandoCupon ? 'Validando...' : 'Aplicar'}
          </Text>
        </TouchableOpacity>
      </View>

      {errorCupon ? (
        <Text style={styles.errorText}>{errorCupon}</Text>
      ) : null}

      <FeedbackModal
        visible={feedback.visible}
        type={feedback.type}
        title={feedback.title}
        message={feedback.message}
        onClose={() => setFeedback(prev => ({ ...prev, visible: false }))}
        confirmText={feedback.type === 'success' ? 'Continuar' : 'Entendido'}
      />
    </>
  );
};

const styles = StyleSheet.create({
  tituloSeccion: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    marginTop: 20,
    marginBottom: 10,
  },
  errorText: {
    color: colores.error || 'red',
    fontSize: 14,
    marginBottom: 10,
    textAlign: 'center',
  },
  cuponContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    //marginBottom: 10,
  },
  cuponInput: {
    flex: 1,
    height: 46,
    borderWidth: 1,
    borderColor: colores.grisClaro,
    borderRadius: 4,
    paddingHorizontal: 12,
    color: colores.textoPrincipal,
    fontSize: 14,
  },
  cuponBoton: {
    backgroundColor: colores.rojo,
    height: 46,
    paddingHorizontal: 15,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
    borderRadius: 4,
  },
  cuponBotonTexto: {
    color: colores.blanco,
    fontWeight: 'bold',
    fontSize: 14,
  },
});

export default CuponDescuento;
